import React, { Component } from 'react';
import GrillaProcesos from './GrillaProcesos';
import { Icon } from 'react-fa';
import AutocompleteProcesos from './AutocompleteProcesos';

function formatProcesoString(proceso) {
    if (proceso == undefined)
        return "";

    return proceso.numero + " (" + proceso.fecha + ")";
}

const procesosPorPagina = 9;

class ProcessPicker extends Component {

    constructor(props) {
        super(props);
        const limiteRangos = Math.floor(props.procesos.length / procesosPorPagina) + 1;
        this.state = { rangoElegido: 0, limiteRangos: limiteRangos };
    }

    cambiarRango(index) {

        if (index < 0 || index >= this.state.limiteRangos)
            return;
        const { cambiarRangoPagina } = this.props;
        //this.setState({ rangoElegido: index });
        cambiarRangoPagina(index);

    }

    render() {
        
        const { procesos, cambiarFila, filaElegida, filtrarFn, cambiarRangoPagina } = this.props;

        const { rangoIndex } = this.props;

        const rangoElegido = rangoIndex;

        const rangoFin = procesosPorPagina * (rangoElegido + 1);
        const rangoInicio = procesosPorPagina * rangoElegido;

        let ultimoProcesoIndex;

        if (procesos.length % procesosPorPagina === 0)
            ultimoProcesoIndex = procesosPorPagina - 1;
        else
            ultimoProcesoIndex = procesos.length - 1;

        const procesosGrilla = procesos.slice(rangoInicio, rangoFin);
        const primerProceso = procesosGrilla[0];
        const ultimoProceso = procesosGrilla[ultimoProcesoIndex];           

        const rangoProcesos = formatProcesoString(primerProceso) + " - " + formatProcesoString(ultimoProceso);
       
        return (
        <div className="DeliveryTarjetasContainer-ProcessPicker">                
            <br />
            <AutocompleteProcesos
                    placeholder="Nº o por fecha del proceso"
                    procesos={procesos}
                    cambiarFila={cambiarFila}
                    rangoElegido={this.state.rangoElegido}
                    cambiarRangoPagina={cambiarRangoPagina}
                />              
            <div>
                <p>
                    <Icon name="chevron-left" onClick={() => this.cambiarRango(rangoElegido - 1)} />
                    &nbsp; {rangoProcesos} &nbsp;
                    <Icon name="chevron-right" onClick={() => this.cambiarRango(rangoElegido + 1)} />
                </p>
            </div>
            <GrillaProcesos procesosGrilla={procesosGrilla} cambiarFila={cambiarFila} filaElegida={filaElegida} />
            <br />
        </div>
        );

    }

}

export default ProcessPicker;